export default __webpack_public_path__ + "static/media/mysql.7e22b744.svg";